<template>
    <div class="highlights dark-mode" v-if="highlight">
        <nav class="top-navbar" v-if="highlight.event">
            <div class="title">
                <div class="title-inner">
                    <span v-i18n="'HIGHLIGHT_FROM'"/>
                    <span v-hg-event-title="{event: highlight.event}"/>
                    <span class="subtitle">
                        &nbsp;(<span class="datetime">{{highlight.event.start_timestamp | moment("ddd D MMM")}}</span>)
                    </span>
                </div>
            </div>
            <div class="icon-right">
                <help/>
            </div>
        </nav>
        <div class="highlight-wrapper">
            <div class="highlight-player hg-player">
                <video :src="url" :poster="$hisport.absolute(highlight.preview_url, {default:'/images/highlight_default.png', w: 640, q: 80, f: 'jpg'})" controls preload="metadata"/>
            </div>
            <div class="highlight-details">
                <!-- <div class="row">
                    <label v-i18n="'CREATOR'" v-if="highlight.user_creator" />
                    <router-link  :to="'/users/' + highlight.user_creator.id">
                        {{highlight.user_creator.name}}
                    </router-link>
                </div> -->

                <div class="row">
                    <label v-i18n="'CREATED_AT'" />
                    <span>{{highlight.created_at | moment("ddd D MMM YYYY HH:mm")}}</span>
                </div>
                <div class="row">
                    <label v-i18n="'UPDATED_AT'" />
                    <span>{{highlight.updated_at | moment("ddd D MMM YYYY HH:mm")}}</span>
                </div>
                 <!-- <div class="row" v-if="$hisport.getUserId() == this.highlight.id_creator">
                    <button class="btn btn-red" v-i18n="'REMOVE'" @click="showModal"/>
                    <modal-adaptive />
                </div> -->

                <!-- <div class="row">
                    <label v-i18n="'HIGHLIGHT_EVENT'" />
                    <router-link :to="'/events/' + highlight.event.id">
                        <span v-hg-event-title="{event: highlight.event}"/>
                    </router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>
<style scoped>
.title-inner span{
    margin-left:5px;
}
.highlight-wrapper{
    display:flex;
    height: calc(100vh - var(--sidebar-width));
}

.highlight-details{
    text-align:left;
    display: flex;
    flex-direction: column;
    width: 350px;
    height: 100%;
    text-align: left;
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    border-left-color: rgba(255,255,255,.15);
    padding:10px;
}
.highlight-details .row{
    display:flex;
    flex-direction: column;
}
.highlight-details .row + .row{
    margin-top:20px;
}
.highlight-details .row label{
    width: 150px;
    flex: 0 0 auto;
}
.highlight-player{
    width: calc(100% - 300px);
}
.highlight-player highlight{
    height: calc(100vh - 91px);
}
</style>
<script>
import { HELPERS }  from 'morpheos.hisport.vueplugin';
import help from "../_components/help";
// import modalAdaptive from "../_components/modal_adaptive"

export default {
    title: "HIGHLIGHT_FROM",
    components:{
        help
    //     modalAdaptive
    },
    mounted(){
      var self = this;
      console.log("id", this.$route.params.id);
      this.$hisport.datacontext.highlight.getById(this.$route.params.id, {include: ["event","teams","users","tag","tag_type"]})
        .then(function(highlight){
            if(!highlight.visibility_custom)
                highlight.visibility_custom = [];
            self.highlight = highlight;
            self.$store.dispatch("setLoading", false);
        });
    },
    data(){
        return {
            highlight: null,
            visibilities: Object.keys(this.$hisport.visibility_types)
        }
    },
    methods:{
        updateHIGHLIGHT: function(){
            this.$hisport.datacontext.highlight.update(this.highlight)
            .then(function(){})
            .catch(function(err){console.error(err)})
        },
        // removeHighlight: function() {
        //     var self = this;
        //     if(self.highlight && self.highlight.id) {
        //         console.log(self.highlight.storage_url, "removed");
        //     }
        // },
        // showModal: function() {
        //     var self = this;
        //     this.$modal.show('modal-adaptive', {
        //         header: self.$hisport.i18n('REMOVE'),
        //         message:  self.$hisport.i18n('IRREVERSIBLE_REMOTION'),
        //         onConfirm() {
        //             self.$modal.hide('modal-adaptive');
        //             self.removeHighlight();
        //         }
        //     });
        // }
    },
    computed: {
        url: function(){
            if(this.highlight)
                return HELPERS.getVideoUrl(this.highlight);
            return null;
        }
    }
}
</script>